import apiEndPoints from '../../../routeConfig';
import { ApiService } from '../../../../service/api.service';
import { attempt } from '../../../../service/apiResult';

const apiService = new ApiService();

const asList = (response) => (Array.isArray(response?.data) ? response.data : []);

/** `{ success, data: plan[] }`; filters are optional. */
export const listInitiativePlans = async ({ initiativeId, countryId } = {}) => {
  const query = new URLSearchParams();
  if (initiativeId) query.set('initiativeId', initiativeId);
  if (countryId) query.set('countryId', countryId);
  const suffix = query.toString() ? `?${query}` : '';
  return attempt(async () => asList(await apiService.get(`${apiEndPoints.initiativePlans}${suffix}`)));
};

/** The eKutir Initiatives with the countries each is offered in. */
export const getInitiativePlanOptions = async () =>
  attempt(async () => asList(await apiService.get(`${apiEndPoints.initiativePlans}/initiatives`)));

export const getInitiativePlan = async (id) =>
  attempt(async () => (await apiService.get(`${apiEndPoints.initiativePlans}/${id}`)).data);

export const saveInitiativePlan = async (body, id) =>
  attempt(() => (id ? apiService.update(`${apiEndPoints.initiativePlans}/${id}`, body) : apiService.post(apiEndPoints.initiativePlans, body)));

export const setInitiativePlanStatus = async (id, status) =>
  attempt(() => apiService.patch(`${apiEndPoints.initiativePlans}/${id}/status/${status}`, ''));

export const deleteInitiativePlan = async (id) =>
  attempt(() => apiService.delete(`${apiEndPoints.initiativePlans}/${id}`));
